import React from 'react';
import PropTypes from 'prop-types';
import DataRow from './DataRow';
import DateDivider from './DateDivider';
import { ErrorMessage } from '../common';
import { ERROR_MESSAGE_SCREEN } from '../../constants';
import NoAppntIcon from 'assets/images/NoAppntIcon.svg';
const moment = require('moment');

const DateView = ({ ...props }) => {
  let currentDate = '';

  function showDate (appointment) {
    const appointmentDate = moment(appointment.startDate).format('dddd, MMMM D');
    if (currentDate !== appointmentDate) {
      currentDate = appointmentDate;
      return true;
    }
    return false;
  }

  return (
    <React.Fragment>
      {
        (props.appointments || []).length === 0 ? <ErrorMessage errorMessage={ERROR_MESSAGE_SCREEN.NO_APPOINTMENTS} errorImage={NoAppntIcon} />
          : <div className='date-view-container'>
            {
              (props.appointments || [])
                .sort((a, b) => (moment(a.startDate) - moment(b.startDate)))
                .map((appointment, index) => {
                  return <React.Fragment key={index}>
                    {showDate(appointment) ? <DateDivider date={appointment.startDate} /> : ''}
                    <DataRow appointment={appointment} />
                  </React.Fragment>;
                })
            }
          </div>
      }
    </React.Fragment>
  );
};

DateView.propTypes = {
  appointments: PropTypes.array.isRequired
};

export default DateView;
